import React from 'react'

import {InitContext} from './components/init-context'
import {ObjectStore} from './components/object-store'
import Log from './components/log'
import {RouterContext} from './utils/use-hash'
import {SpinningContext} from './components/spinning-context'
import './app.scss'



export default function App() {
    return <RouterContext>
        <SpinningContext>
        <ObjectStore>
            <InitContext>
                <Log />
            </InitContext>
            <canvas id="confettiCanvas"></canvas>
            <canvas id="balloonCanvas"></canvas>
        </ObjectStore>
        </SpinningContext>
    </RouterContext>
}
